import endpoint from 'src/store/modules/endpoint'
import {
  digitGroup
} from 'src/helpers'

export const negotiation = {
  dialog: {
    accept: {
      show: false,
      title: 'Setujui Negosiasi',
      description: 'Dengan menekan tombol "<strong>Setuju</strong>", pengguna dapat melakukan transaksi sesuai dengan harga yang diminta',
      button: 'Ya, Setujui Sekarang'
    },
    cancel: {
      show: false,
      title: 'Tolak Negosiasi',
      description: 'Dengan menekan tombol "<strong>Tolak Negosiasi</strong>", pengguna harus diajukan kembali. Mohon untuk memasukan alasan penolakan',
      button: 'Tolak Negosiasi'
    },
    changeNotSaved: {
      show: false,
      title: 'Perubahan Belum Disimpan',
      description: 'Data harga dan tanggal pengiriman yang dimasukan belum disimpan dan dapat hilang',
      button: 'Tetap Disini'
    },
    notif: {
      descriptionTimein: 'Kami menghargai waktu pembeli, segera selesaikan proses negosiasi!',
      descriptionTimeout: 'Proses negosiasi tidak dapat diproses, harap membuat negosiasi yang baru'
    }
  },

  detail: {
    products: {
      columns: [
        {
          name: 'productName',
          required: true,
          label: 'Produk',
          align: 'left',
          field: 'productName',
          headerClasses: 'bg-info'
        },
        {
          name: 'shippingType',
          label: 'Pengiriman',
          field: 'shippingType',
          headerClasses: 'bg-info',
          align: 'left'
        },
        {
          name: 'sum',
          label: 'Jumlah',
          headerClasses: 'bg-info',
          field: 'sum'
        },
        {
          name: 'cogsPrice',
          label: 'Harga COGS',
          field: row => {
            return `Rp ${digitGroup(row.priceCogs)}`
          },
          headerClasses: 'bg-info'
        },
        {
          name: 'productPrice',
          label: 'Harga Jual',
          field: row => {
            return `Rp ${digitGroup(row.productPrice)}`
          },
          headerClasses: 'bg-info'
        },
        {
          name: 'negoPrice',
          label: 'Harga Diminta',
          field: 'negoPrice',
          headerClasses: 'bg-info'
        },
        {
          name: 'finalPrice',
          label: 'Harga Akhir',
          field: '',
          headerClasses: 'bg-primary-50'
        }
      ],

      data: []
    },

    summary: {
      columns: [
        {
          name: 'label',
          label: 'Ringkasan',
          align: 'left',
          field: 'label',
          headerClasses: 'bg-info'
        },
        {
          name: 'start',
          label: 'Harga Awal',
          align: 'right',
          field: 'start',
          headerClasses: 'bg-info',
          classes: 'text-right'
        },
        {
          name: 'nego',
          label: 'Harga Diminta',
          align: 'right',
          field: 'nego',
          headerClasses: 'bg-info',
          classes: 'text-right'
        },
        {
          name: 'finalPrice',
          label: 'Harga Akhir',
          align: 'right',
          field: row => `Rp ${digitGroup(row.final)}`,
          headerClasses: 'bg-info'
        }
      ],

      data: []
    },

    shipping: {
      columns: [
        {
          name: 'label',
          label: 'Biaya Pengiriman',
          align: 'left',
          field: 'label',
          headerClasses: 'bg-info'
        },
        {
          name: 'totalShippingPrice',
          label: 'Harga Awal',
          align: 'right',
          field: row => 'Rp ' + digitGroup(row.totalShippingPrice),
          headerClasses: 'bg-info'
        },
        {
          name: 'finalShippingPrice',
          label: 'Harga Diminta',
          align: 'right',
          field: 'finalShippingPrice',
          headerClasses: 'bg-info'
        }
      ],

      data: []
    },

    discount: {
      columns: [
        {
          name: 'ringkasanDiskon',
          label: 'Ringkasan Diskon',
          field: 'ringkasanDiskon',
          align: 'left',
          headerClasses: 'bg-info'
        },
        {
          name: 'hargaAwal',
          label: 'Harga Awal',
          field: row => {
            return row.hargaAwal
              ? `Rp ${digitGroup(row.hargaAwal)}`
              : '-'
          },
          headerClasses: 'bg-info'
        },
        {
          name: 'hargaDiminta',
          label: 'Harga Diminta',
          field: row => {
            return row.hargaDiminta
              ? `Rp ${digitGroup(row.hargaDiminta)}`
              : '-'
          },
          headerClasses: 'bg-info'
        }
      ],

      data: []
    }
  }
}

export const negoListTabAll = {
  api: endpoint.state.bid,
  exportApi: endpoint.state.bid,
  columns: [
    {
      name: 'name',
      label: 'Pemohon',
      align: 'left',
      field: (row) => {
        const name = row.company_data?.name
          ? `<div
            class="text-capitalize"
            router-push="${
              encodeURIComponent(
                JSON.stringify({
                  name: 'nego-detail',
                  params: {
                    action: 'preview',
                    id: row.id
                  }
                })
              )
            }"
            >${row.company_data?.name}</div>`
          : '-'
        const bidNo = row.nego_no
          ? `<div class="text-caption text-grey">${row.nego_no}</div>`
          : '-'
        return name + bidNo
      },
      sortable: false,
      rowClass: 'text-no-wrap'
    },
    {
      name: 'so_no',
      label: 'No. Sales Order',
      field: row => {
        return row.so_no
          ? `<div
            class="text-capitalize"
            router-push="${
              encodeURIComponent(
                JSON.stringify({
                  name: 'so-detail',
                  params: {
                    action: 'preview',
                    id: row?.so_id,
                    name: row.so_no
                  }
                })
              )
            }"
            >${row.so_no}</div>`
          : '-'
      },
      rowClass: 'text-no-wrap'
    },
    {
      name: 'created_at',
      label: 'Tanggal Pengajuan',
      field: 'created_at',
      align: 'left',
      sortable: true,
      commonDate: true
    },
    {
      name: 'payment_type',
      label: 'Jenis Pembayaran',
      field: row => {
        if (!row.payment_type || row.payment_type === '-') return '-'

        const paymentType = {
          TUNAI: 'Tunai',
          TERMIN: {
            'JM TEMPO': 'JM Tempo',
            'JM PAYLATER': 'JM Paylater',
            PAPER: 'Paper.id',
            KOINWORKS: 'Koinworks',
            CREDILINQ: 'Credilinq.ai'
          }[row.bnpl_name] || row.bnpl_name
        }[row.payment_type]

        const terminDay = {
          TUNAI: '',
          TERMIN: `<span class="text-grey-7">${row.termin_day} hari</span>`
        }[row.payment_type]

        const image = {
          TUNAI: require('src/assets/images/icons/24x24-tunai-circle.png'),
          TERMIN: row.image_payment
        }[row.payment_type]

        return `<div class="flex no-wrap items-center gap-2">
          <img
            src="${image}"
            alt="${row.payment_type}"
            class="payment-type-img"
          >
          <div class="flex column gap-1">
            <strong>${paymentType}</strong>
            ${terminDay}
          <div>
        </div>`
      }
    },
    {
      name: 'product_name',
      label: 'Nama Produk',
      field: row => {
        const otherItemTotal = row.nego_item?.length > 1
          ? `<div class="text-grey-7">
            +${row.nego_item?.length - 1} Lainnya
          </div>`
          : ''
        return `<span>${row.nego_item[0].product_name}</span>` +
          otherItemTotal
      },
      rowClass: 'td-width-medium'
    },
    {
      name: 'start_price',
      label: 'Harga Awal',
      align: 'right',
      field: (row) => {
        return 'Rp' + digitGroup(row.start_price) || '-'
      },
      rowClass: 'text-right'
    },
    {
      name: 'total_nego_price',
      label: 'Harga Diminta',
      align: 'right',
      field: (row) => {
        const differencePricePrecentage = parseFloat(row.difference_price_precentage)
        return row.total_nego_price
          ? `<div class="text-right">
              <div class="text-no-wrap">
                Rp ${digitGroup(row?.total_nego_price)}
              </div>
              <div
                role="alert"
                class="${
                  {
                    true: 'custom-badge-red',
                    false: 'custom-badge-green'
                  }[differencePricePrecentage < 0]
                } dense"
                style="min-width: 80px;"
              >
                <span class="flex items-center no-wrap">
                  <span class="material-icons q-pr-xs">
                    ${
                      {
                        true: 'south',
                        false: 'north'
                      }[differencePricePrecentage < 0]
                    }
                  </span>
                  ${row.difference_price_precentage}%
                </span>
              </div>
            </div>`
          : '-'
      }
    },
    {
      name: 'total_final_price',
      label: 'Harga Akhir',
      align: 'right',
      field: (row) => {
        const difference = parseFloat(row?.total_final_price_precentage)
        const isMinus = difference < 0
        const diffNego = row?.total_final_price

        return diffNego
          ? `<div class="text-right">
              <div class="text-no-wrap">
                Rp ${
                  {
                    true: digitGroup(diffNego)
                  }[diffNego !== null] || '-'
                }
              </div>` +
              `<div
                role="alert"
                class="${
                  {
                    true: 'custom-badge-red',
                    false: 'custom-badge-green'
                  }[isMinus]
                } dense"
                style="min-width: 80px;"
              >
                <span class="flex items-center no-wrap">
                  <span class="material-icons q-pr-xs">
                    ${
                      {
                        true: 'south',
                        false: 'north'
                      }[isMinus]
                    }
                  </span>
                  ${
                    {
                      true: difference + '%'
                    }[!!difference] || '-'
                  }
                </span>
              </div>
            </div>`
          : '-'
      }
    },

    // -----------------------
    // {
    //   name: 'processed_at',
    //   label: 'Tanggal Diproses',
    //   field: 'processed_at',
    //   align: 'left',
    //   sortable: true,
    //   commonDate: true
    // },

    {
      name: 'referal_code',
      label: 'Sales',
      field: (row) => {
        return row.company_data?.referal_code || '-'
      },
      align: 'left'
    },
    {
      name: 'nego_status',
      label: 'Status',
      field: (row) => {
        return {
          Diminta: `<div role="alert" class="custom-badge custom-badge-purple">${row.nego_status}</div>`,
          Disetujui: `<div role="alert" class="custom-badge custom-badge-green">${row.nego_status}</div>`,
          Ditolak: `<div role="alert" class="custom-badge custom-badge-red">${row.nego_status}</div>`
        }[row.nego_status] || row.nego_status
      },
      align: 'left',
      rowClass: 'text-no-wrap'
    }
  ]
}
